import React, { useEffect, useState } from 'react';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import $ from 'jquery';
import { get } from '../controllers/apiController';
import { useAuth } from '../context/AuthContext';

import "react-toastify/dist/ReactToastify.css";

const Layout = ({ children }) => {
    const { user } = useAuth();

    const [reminderAgencies, setReminderAgencies] = useState([]);
    const [showReminderModal, setShowReminderModal] = useState(false);

    useEffect(() => {
        if (!user) return;

        const today = new Date().toISOString().slice(0, 10);
        const storageKey = `acenteHatirlatmaGosterildi_${today}_${user.Kullanici_ID}`;

        if (sessionStorage.getItem(storageKey)) return;

        const fetchReminders = async () => {
            try {
                const res = await get("acenteler/reminders/today");

                if (res && res.length > 0) {
                    setReminderAgencies(res);
                    setShowReminderModal(true);
                }

                sessionStorage.setItem(storageKey, '1');
            } catch (err) {}
        };

        fetchReminders();
    }, [user]);

    useEffect(() => {
        $("#mobile-collapse").on("click", function(e) {
            e.preventDefault();
            if ($(".nxl-navigation").hasClass("mob-navigation-active")) {
                $(".nxl-navigation").removeClass("mob-navigation-active");
                $(".nxl-navigation .nxl-menu-overlay").remove();
            } else {
                $(".nxl-navigation").addClass("mob-navigation-active");
                $(".nxl-navigation").append('<div class="nxl-menu-overlay"></div>');
                $(".nxl-navigation .nxl-menu-overlay").on("click", function() {
                    $(".nxl-navigation").removeClass("mob-navigation-active");
                    $(".hamburger").removeClass("is-active");
                    $(this).remove();
                });
            }
        });

        $("#menu-mini-button").on("click", function() {
            $("#menu-mini-button").hide();
            $("#menu-expend-button").show();
            $("html").addClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-mini-theme");
        });

        $("#menu-expend-button").on("click", function() {
            $("#menu-expend-button").hide();
            $("#menu-mini-button").show();
            $("html").removeClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-expend-theme");
        });

        $(document).on("click", ".search-form-open-toggle", function(e) {
            e.preventDefault();
            $(".search-form").addClass("search-form-active").show(300);
        });

        $(document).on("click", ".search-form-close-toggle", function(e) {
            e.preventDefault();
            $(".search-form").removeClass("search-form-active").hide(300);
        });

        $(".app-sidebar-open-trigger").on("click", function(e) {
            e.preventDefault();
            $(".content-sidebar").addClass("app-sidebar-open");
        });

        $(".app-sidebar-close-trigger").on("click", function(e) {
            e.preventDefault();
            $(".content-sidebar").removeClass("app-sidebar-open");
        });

        $(document).on("click", ".page-header-right-open-toggle", function(e) {
            e.preventDefault();
            $(".page-header-right-items").addClass("page-header-right-open").removeClass("page-header-right-close");
        });

        $(document).on("click", ".page-header-right-close-toggle", function(e) {
            e.preventDefault();
            $(".page-header-right-items").addClass("page-header-right-close").removeClass("page-header-right-open");
        });

        $(document).on("click", ".page-content-left-open-toggle", function(e) {
            e.preventDefault();
            $(".page-content-left-sidebar-wrapper").addClass("page-content-left-open").removeClass("page-content-left-close");
        });

        $(document).on("click", ".page-content-left-close-toggle", function(e) {
            e.preventDefault();
            $(".page-content-left-sidebar-wrapper").addClass("page-content-left-close").removeClass("page-content-left-open");
        });

        $(document).on("click", ".page-content-right-open-toggle", function(e) {
            e.preventDefault();
            $(".page-content-right-sidebar-wrapper").addClass("page-content-right-open").removeClass("page-content-right-close");
        });

        $(document).on("click", ".page-content-right-close-toggle", function(e) {
            e.preventDefault();
            $(".page-content-right-sidebar-wrapper").addClass("page-content-right-close").removeClass("page-content-right-open");
        });

        return () => {
            $("#mobile-collapse").off("click");
            $(".nxl-navigation .nxl-menu-overlay").off("click").remove();
        };
    }, []);

    return (
        <div>
            <Header />
            <Menu />
            <div className="content">
                {children}
            </div>
            {/* <Footer /> */}
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            {showReminderModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="feather-bell text-danger me-2"></i>
                                    Bugünkü Acente Hatırlatmaları
                                </h5>
                                <button type="button" className="btn-close" onClick={() => setShowReminderModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <ul className="list-group">
                                    {reminderAgencies.map(agency => (
                                        <li key={agency.Acente_ID} className="list-group-item">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <a href={`./agency-detail?id=${agency.Acente_ID}`} className="fw-bold">{agency.Acente_Adi}</a>
                                                <span className="text-danger fw-bold">
                                                    {new Date(agency.Hatirlatma_Tarihi).toLocaleString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                                                </span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowReminderModal(false)}>Kapat</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showReminderModal && (
                <div
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1040 }}
                    onClick={() => setShowReminderModal(false)}
                />
            )}
        </div>
    );
};

export default Layout;
